import breakpoint from '../scripts/breakpoint';
import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-barContent';
	var desktop = $('.i-barContent-lg');
	var mobile = $('.i-barContent-xs');

	$(base, context).each(function(){
		var component = $(this).find(base + '-inner');

		function toggler() {
			$(this).next().toggle();

			if ($(this).hasClass('m-active')) {
				$(this).removeClass('m-active');
			} else {
				$(this).addClass('m-active');
			}
		}

		breakpoint('xs', 'lg')
			.onmatch(function(){
				component.appendTo(mobile);
			})
			.onmismatch(function(){
				component.appendTo(desktop);
			});
	});
});

$.addInit(function(context){
	var base = '.i-barContent-xs';
	$(base, context).each(function(){
		var component = $(this);

		breakpoint('lg')
			.onmatch(function(){
				component.closest('.b-modal').trigger('close');
			});
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/components/i-filterBar-lg.js
// module id = 55
// module chunks = 0